export default "__VITE_ASSET__8sZ55edJ__"